import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import { VisbilityContainer, CommonPose } from '../home/Animations'
import {
  Container,
  VerticalPad,
  Content,
  ChaliceImg,
  ProductH3,
  interpolate
} from '../theme/default/base'

const SideImageBlock = styled.div`
  background-color: ${(props) => props.backgroundColor || '#fff'};
  min-height: 500px;
  display: flex;
  align-items: center;
  position: relative;

  h2 {
    font-size: 1.2rem;
  }

  img {
    width: 100%;
    height: auto;
    transition: all 0.25s;
    border-radius: 20px;
  }
`

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  background-color: ${(props) => props.backgroundColor};
`

const SideImageLeft = styled.div`
  width: 50%;
  padding-right: 50px;
  background-color: ${(props) => props.backgroundColor || 'transparent'};
  z-index: ${(props) => props.zIndex || '10'};

  & > div {
    padding-bottom: 20px;
  }

  .action-row {
    ${(props) => props.theme.media.tablet`
      flex-direction: row;
    `}
  }

  ${(props) => props.theme.media.tablet`
    width: 100%;
    padding: 50px 0;
  `}
`

const SideImageRight = styled.div`
  padding-left: 50px;
  width: 50%;
  background-color: ${(props) => props.backgroundColor || 'transparent'};
  z-index: ${(props) => props.zIndex || '10'};

  ${(props) => props.theme.media.tablet`
    width: 100%;
    padding: 0;
  `}
`

const SideImageCentered = styled.div`
  width: 60%;
  margin: 0 auto;
  background-color: ${(props) => props.backgroundColor || 'transparent'};
  z-index: ${(props) => props.zIndex || '10'};

  ${(props) => props.theme.media.tablet`
    width: 100%;
    padding: 0;
  `}
`

export const ProductSection = inject('store')(
  observer(
    ({
      title,
      description,
      imageUrl,
      store,
      reverse = false,
      bgColor = 'transparent',
      sideColor = 'transparent'
    }) => {
      let left = (
        <>
          <CommonPose>
            <ProductH3>{interpolate(store.siteData, title)}</ProductH3>
          </CommonPose>
          <CommonPose dangerouslySetInnerHTML={{ __html: description }} />
        </>
      )
      let right = (
        <>
          <CommonPose>
            <ChaliceImg src={imageUrl} />
          </CommonPose>
        </>
      )

      if (!imageUrl) {
        return (
          <VisbilityContainer>
            <SideImageBlock>
              <Background backgroundColor={bgColor}></Background>
              <Container>
                <VerticalPad>
                  <Content>
                    <SideImageCentered>{left}</SideImageCentered>
                  </Content>
                </VerticalPad>
              </Container>
            </SideImageBlock>
          </VisbilityContainer>
        )
      }
      let rightBgColor = sideColor
      let leftBgColor = 'transparent'
      if (reverse) {
        ;[right, left] = [left, right]
      }
      if (reverse) {
        ;[rightBgColor, leftBgColor] = [leftBgColor, rightBgColor]
      }
      return (
        <VisbilityContainer>
          <SideImageBlock>
            <Background backgroundColor={bgColor}>
              <SideImageLeft
                zIndex="1"
                backgroundColor={leftBgColor}
              ></SideImageLeft>
              <SideImageRight
                zIndex="1"
                backgroundColor={rightBgColor}
              ></SideImageRight>
            </Background>
            <Container>
              <VerticalPad>
                <Content>
                  <SideImageLeft> {left} </SideImageLeft>
                  <SideImageRight> {right} </SideImageRight>
                </Content>
              </VerticalPad>
            </Container>
          </SideImageBlock>
        </VisbilityContainer>
      )
    }
  )
)

ProductSection.propTypes = {
  bgColor: PropTypes.string,
  sideColor: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  imageUrl: PropTypes.any,
  reverse: PropTypes.bool,
  cta: PropTypes.any
}
